import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  translationManagementService,
  GetTranslationsParams,
  UpdateTranslationItemParams,
} from '@/services/core/translationManagementService';

export function translationManagementQueryKey(params: GetTranslationsParams) {
  return ['translations-management', params] as const;
}

export function useTranslationManagement(params: GetTranslationsParams, enabled = true) {
  return useQuery({
    queryKey: translationManagementQueryKey(params),
    queryFn: () => translationManagementService.getList(params),
    enabled: !!params.language && enabled,
    staleTime: 30_000,
  });
}

export function useUpdateTranslationItem() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateTranslationItemParams) => translationManagementService.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['translations-management'] });
    },
  });
}
